import React from "react";
import { orderStatus } from "../../constants/commonConstants";
import { formatOrderCreatedDate } from "../../utils/dateFormating";

const TutorialCard = ({
  id,
  title,
  subtitle,
  price,
  date,
  time,
  status,
  count,
  onClick,
  isActive, // New prop to determine if the card is active
}) => {
  date = formatOrderCreatedDate(date);
  
  const borderColor =
    status === orderStatus.PENDING_PAYMENT ||
    status === orderStatus.IN_REVISION ||
    status === orderStatus.COMPLAINT_RAISED
      ? "border-light-red"
      : status === orderStatus.ORDER_IN_PROGRESS
      ? "border-[#06BCCC]"
      : status === orderStatus.ORDER_DELIVERED ||
        status === orderStatus.COMPLETED ||
        status === orderStatus.RESOLVED
      ? "border-blue-500"
      : "border-default";

  const headerTextColor = isActive ? "text-blue-shades" : "text-primary";

  return (
    <div
      onClick={onClick}
      className={` relative border rounded-[5px] p-4 w-[240px] h-auto cursor-pointer ${borderColor} ${
        isActive ? "bg-soft-green" : "bg-white"
      }`}
    >
      {count > 0 && (
        <div className=" absolute top-[-12px] right-[-18px] bg-blue-shades h-[24px] w-[36px] rounded-full text-white font-inter text-[16px] leading-[13.31px] inline-flex items-center justify-center pt-[1px]">
          {count}
        </div>
      )}
      <div
        className={`font-inter ${headerTextColor} font-semibold leading-[20px] text-[15px]`}
      >
        <span>{id}</span> -{" "}
        <span>
          {title} {subtitle}
        </span>
      </div>
      <div className="mt-[4px] font-inter flex items-end justify-between">
        <div className="text-gray bg-soft-gray rounded-[3px] border border-medium-gray px-[10px] flex items-center font-semibold text-level-4 h-[30px]">
          {price}
        </div>
        <div className="text-gray text-level-5 text-right font-normal">
          <div>
            {date}
            <span>, </span>
            {time}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialCard;